import { render, staticRenderFns } from "./adres2.vue?vue&type=template&id=23a74f1a&scoped=true&"
import script from "./adres2.vue?vue&type=script&lang=js&"
export * from "./adres2.vue?vue&type=script&lang=js&"
import style0 from "./adres2.vue?vue&type=style&index=0&id=23a74f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a74f1a",
  null
  
)

export default component.exports